var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ftr__links"},_vm._l((_vm.links),function(link,i){return _c('app-link',_vm._b({key:("FooterSectionLink" + i),staticClass:"ftr__link",on:{"click":function($event){return _vm.onClick(link)}}},'app-link',link,false))}),1)}
var staticRenderFns = []

export { render, staticRenderFns }